export const PUB_SUB_ACTION = <const>{
	EXPIRATION_SET: 'EXPIRATION_SET',
	EXPIRATION_UNSET: 'EXPIRATION_UNSET',
};
